
export enum LabelShapeType {
    STARBURST = "starburst",
    RIBBON = "ribbon",
}
